import React from 'react';
import {Cols} from '../../components';
import AboutLayer from './AboutLayer';
import './Product.less';
import ProductCards from './ProductCard';

function Product({data, children, lg, md, lm, ...props}) {
  return (
    <AboutLayer {...props}>
      <div className='Product'>
        <ProductCards data={data[0]} first={true}/>
        <Cols {...{lg, md, lm, data: data.slice(1)}}>
          {children}
        </Cols>
      </div>
    </AboutLayer>
  );
}

export default Product;



// WEBPACK FOOTER //
// ./src/routes/About/Product.js